// Panelin liste ekranlarında ortak sayfa çubuğu hesabı.
//
// Kural KYC listesinde doğdu ve Spor Bahisleri de aynı çubuğu çiziyor; iki
// kopya ayrışırsa aynı sayfalama iki ekranda farklı davranırdı (birinde uçlar
// görünür, diğerinde kaybolur).

/**
 * Sayfa çubuğunda gösterilecek numaralar.
 *
 * Bütün sayfaları basmak 40 sayfalık bir listede çubuğu satır satır
 * taşırıyordu; uçlar her zaman görünür, arası `'gap'` ile kısaltılır.
 */
export const pageWindow = (page, pageCount, span = 1) => {
  if (pageCount <= 1) return [0];
  const pages = new Set([0, pageCount - 1, page]);
  for (let step = 1; step <= span; step += 1) {
    if (page - step >= 0) pages.add(page - step);
    if (page + step <= pageCount - 1) pages.add(page + step);
  }
  const sorted = [...pages].sort((a, b) => a - b);
  const output = [];
  sorted.forEach((value, index) => {
    if (index > 0 && value - sorted[index - 1] > 1) output.push('gap');
    output.push(value);
  });
  return output;
};


// Sayfa başına satır sayısı yöneticinin tercihidir.
//
// Liste ekranları uzun süre sabit 25 satır gösterdi ve "üyenin bütün
// turlarını görmek" sayfa sayfa ilerlemek demekti. Seçenek kümesi burada
// durur; ekran başına kopyalansaydı biri 100, diğeri 500 tavanı sunar ve
// uç, listede görünmeyen bir değeri 422 ile geri çevirirdi.
export const PAGE_SIZES = [25, 50, 100, 250, 500];

// "Tümü" seçeneğinin gerçek değeri. Sınırsız bir liste **yoktur**: uygulama
// tek uvicorn worker ile çalışır (bkz. CLAUDE.md, *Panelin ağır sorguları
// bütün siteyi bekletir*) ve sanallaştırma olmadan binlerce satırı çizmek
// yöneticinin tarayıcısını da kilitler. Toplam bu tavanı aşarsa sayfa
// çubuğu çalışmaya devam eder — yani "Tümü" pratikte "en büyük sayfa"dır.
export const ALL_PAGE_SIZE = 2000;

// Varsayılan değişmez: ekranların bugünkü davranışı korunur ve büyük sayfa
// yöneticinin bilinçli seçimidir.
export const DEFAULT_PAGE_SIZE = PAGE_SIZES[0];

// Tavan backend'deki `limit` doğrulamasıyla **aynı kalmalıdır**
// (services/admin_pagination.py `ADMIN_LIST_MAX_LIMIT`); ayrışırsa panelde
// seçilen değer 422 alır.
export const MAX_PAGE_SIZE = ALL_PAGE_SIZE;

// Seçicinin çizdiği liste. Etiket tek yerdedir: ekran başına yazılsaydı
// aynı kutu bir ekranda "Tümü", diğerinde "2000 satır" derdi.
export const PAGE_SIZE_OPTIONS = [
  ...PAGE_SIZES.map((size) => ({ value: size, label: `${size} satır` })),
  { value: ALL_PAGE_SIZE, label: 'Tümü' },
];

const SELECTABLE = PAGE_SIZE_OPTIONS.map((option) => option.value);

const storageKey = (scope) => `admin:page-size:${scope || 'default'}`;

/**
 * Yöneticinin son seçtiği sayfa boyutu.
 *
 * Tercih sunucuya değil tarayıcıya yazılır: bir yöneticinin 500 satırlık
 * seçimi diğerinin ekranını ağırlaştırmamalıdır (Herkül'ün sohbet rayı ve
 * Vega'nın görünüm anahtarıyla aynı yaklaşım). Depolama gizli sekmede ya da
 * site verisi kapalıyken okunamayabilir; o durumda varsayılana düşülür.
 */
export const readPageSize = (scope, fallback = DEFAULT_PAGE_SIZE) => {
  // Yedek değer ekrana göre değişir: oyun listesi 100, finans 50, üye
  // geçmişi 25 satırla açılıyordu ve seçici eklenirken bu davranış
  // korunmalıdır — hepsini aynı sayıya çekmek, hiçbir şey istemeyen
  // yöneticinin ekranını sessizce değiştirmek olurdu.
  const initial = SELECTABLE.includes(fallback) ? fallback : DEFAULT_PAGE_SIZE;
  try {
    const stored = Number(window.localStorage.getItem(storageKey(scope)));
    return SELECTABLE.includes(stored) ? stored : initial;
  } catch (error) {
    return initial;
  }
};

/** Seçimi saklar; yazılamaması ekranı bozmaz, tercih o oturumda kalır. */
export const writePageSize = (scope, size) => {
  try {
    window.localStorage.setItem(storageKey(scope), String(size));
  } catch (error) { /* gizli sekmede yazılamaz, seçim yine uygulanır */ }
};

export default pageWindow;
